function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 3.333v23.334A3.334 3.334 0 0013.333 30h23.333M30 36.667V13.333A3.333 3.333 0 0026.666 10H3.333",
  stroke: "#000",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));